import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

interface Alert {
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
}


@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [CommonModule],  
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent  implements OnInit {

  public alerts: Alert[] = [];

  constructor() { }

  ngOnInit() {}

  

  showAlert(message: string, type: 'success' | 'error' | 'warning' | 'info' = 'success') {
    const alert: Alert = { message, type };
    this.alerts.push(alert);

    // Remover o alerta após 3 segundos
    setTimeout(() => {
      this.removeAlert(alert);
    }, 3000);
  }

  private removeAlert(alert: Alert) {
    const index = this.alerts.indexOf(alert);
    if (index > -1) {
      this.alerts.splice(index, 1);
    }
  }

}
